export default __webpack_public_path__ + "static/media/newbie_project5.4a7490db.jpg";